<template>
  <div style="display: flex; flex-direction: column; row-gap: 1rem">
    <div
      v-for="(language, index) in answer"
      :key="index"
    >
      <div>{{ language.lang.name }}: {{ language.lang.value }}</div>
      <div>{{ language.level.name }}: {{ language.level.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguagesAnswer',
  props: {
    answer: {
      type: Array,
      required: true,
    },
  },
};
</script>
